/**
 * modal-base-styles.js
 * Pivvy Modal Swipe Handler - JavaScript extracted from modal-base-styles.liquid
 * Adds swipe up/down to close functionality to all pivvy modals
 */

(function() {
  'use strict';

  const SWIPE_THRESHOLD = 80;
  const SWIPE_VELOCITY_THRESHOLD = 0.5;

  function initSwipeToClose() {
    // Use MutationObserver to attach handlers when modals open
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const dialog = mutation.target;
          if (dialog.classList.contains('pivvy-modal') && dialog.hasAttribute('open')) {
            attachSwipeHandler(dialog);
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open']
    });

    document.querySelectorAll('.pivvy-modal[open]').forEach(attachSwipeHandler);
  }

  function attachSwipeHandler(modal) {
    if (modal.dataset.swipeAttached) return;
    modal.dataset.swipeAttached = 'true';

    const container = modal.querySelector('.pivvy-modal__container');
    const content = modal.querySelector('.pivvy-modal__content');

    let startY = 0;
    let startX = 0;
    let currentY = 0;
    let startTime = 0;
    let isSwiping = false;
    let canSwipe = false;

    const swipeTarget = container || modal;

    swipeTarget.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      startY = touch.clientY;
      startX = touch.clientX;
      currentY = touch.clientY;
      startTime = Date.now();
      isSwiping = false;

      if (content) {
        const isAtTop = content.scrollTop <= 0;
        const isAtBottom = content.scrollTop >= (content.scrollHeight - content.clientHeight - 1);
        const isScrollable = content.scrollHeight > content.clientHeight;
        canSwipe = !isScrollable || isAtTop || isAtBottom;
      } else {
        canSwipe = true;
      }
    }, { passive: true });

    swipeTarget.addEventListener('touchmove', (e) => {
      if (!canSwipe) return;

      const touch = e.touches[0];
      const deltaY = touch.clientY - startY;
      const deltaX = touch.clientX - startX;

      if (!isSwiping && Math.abs(deltaY) > 10) {
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          canSwipe = false;
          return;
        }

        if (content && content.scrollHeight > content.clientHeight) {
          const isAtTop = content.scrollTop <= 0;
          const isAtBottom = content.scrollTop >= (content.scrollHeight - content.clientHeight - 1);

          if (deltaY > 0 && !isAtTop) {
            canSwipe = false;
            return;
          }
          if (deltaY < 0 && !isAtBottom) {
            canSwipe = false;
            return;
          }
        }

        isSwiping = true;
      }

      if (isSwiping) {
        currentY = touch.clientY;

        const resistance = 0.5;
        const translateY = deltaY * resistance;

        modal.classList.add('swiping');
        modal.style.transform = `translateY(${translateY}px)`;
        if (container) {
          container.style.transform = `translateY(${translateY}px)`;
        }

        if (e.cancelable) {
          e.preventDefault();
        }
      }
    }, { passive: false });

    swipeTarget.addEventListener('touchend', () => {
      if (!isSwiping) {
        canSwipe = false;
        return;
      }

      const deltaY = currentY - startY;
      const deltaTime = Date.now() - startTime;
      const absDeltaY = Math.abs(deltaY);
      const velocity = absDeltaY > 30 ? absDeltaY / deltaTime : 0;

      modal.classList.remove('swiping');

      const shouldClose = absDeltaY > SWIPE_THRESHOLD || (absDeltaY > 50 && velocity > SWIPE_VELOCITY_THRESHOLD);

      if (shouldClose) {
        const direction = deltaY > 0 ? 1 : -1;
        modal.classList.add('swipe-closing');
        modal.style.transform = `translateY(${direction * 100}vh)`;
        if (container) {
          container.style.transform = `translateY(${direction * 100}vh)`;
        }

        const backdrop = modal.previousElementSibling;
        if (backdrop && backdrop.classList.contains('pivvy-modal__backdrop')) {
          backdrop.classList.remove('active');
        }

        setTimeout(() => {
          const customElement = modal.closest('size-selector-modal, sizeguide-table-modal, cart-image-magnifier');
          if (customElement && typeof customElement.close === 'function') {
            customElement.close();
          } else {
            modal.close();
            modal.classList.remove('swipe-closing');
            modal.style.transform = '';
            if (container) container.style.transform = '';
            document.body.style.overflow = '';
          }
          modal.dataset.swipeAttached = '';
        }, 200);
      } else {
        modal.style.transform = '';
        if (container) container.style.transform = '';
      }

      isSwiping = false;
      canSwipe = false;
    }, { passive: true });

    modal.addEventListener('close', () => {
      modal.dataset.swipeAttached = '';
      modal.style.transform = '';
      if (container) container.style.transform = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeToClose);
  } else {
    initSwipeToClose();
  }
})();
